// TaskItem Component

/* eslint react/jsx-curly-newline: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import TaskSubItem from '../task_subitem/task_subitem.jsx'
import FieldPriority from '../../form/field_priority/field_priority.jsx'
import Util from '../../../lib/util.jsx'
import TimeClock from '../../../time/time/time_clock/time_clock.jsx'
import { DragSource as dragSource } from 'react-dnd'
import { buildTimer } from '../../../common/timer/timer'
import { TaskTime } from './task_time.jsx'
import { TaskAction } from './task_action.jsx'

const taskItemSource = {
  beginDrag (props, _monitor) {
    const {
      task,
      showTimecardAdd,
      showStart,
      showPause,
      showResume,
      timer,
      canDrag
    } = props

    return {
      dragItemType: 'task',
      id: task.id,
      task,
      showTimecardAdd,
      showStart,
      showPause,
      showResume,
      canDrag,
      timer
    }
  },
  endDrag (_props, _monitor) {}
}

class TaskItem extends Component {
  constructor (props) {
    super(props)

    this.data = {
      showExpand: false
    }
  }

  static get propTypes () {
    return {
      activityIsActive: PropTypes.bool,
      active: PropTypes.bool,
      task: PropTypes.object,
      onEdit: PropTypes.func,
      onChangePriority: PropTypes.func,
      onToggleCompleted: PropTypes.func,
      onAddTime: PropTypes.func,
      onStart: PropTypes.func,
      onPause: PropTypes.func,
      onResume: PropTypes.func,
      showTimecardAdd: PropTypes.bool,
      showStart: PropTypes.bool,
      showPause: PropTypes.bool,
      showResume: PropTypes.bool,
      canDrag: PropTypes.bool,
      timer: PropTypes.object,
      hideActions: PropTypes.bool,
      stopAndCreateNewTimeCard: PropTypes.func,
      showVisibleOption: PropTypes.bool,
      onToggleVisibility: PropTypes.func,
      isDragging: PropTypes.bool,
      connectDragSource: PropTypes.func,
      connectDragPreview: PropTypes.func,
      onCompleteSubtask: PropTypes.func,
      onCollapse: PropTypes.func,
      dragEnable: PropTypes.bool,
      isExpanded: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      activityIsActive: false,
      active: false,
      task: null,
      onEdit: null,
      onChangePriority: null,
      onToggleCompleted: null,
      onAddTime: null,
      onStart: null,
      onPause: null,
      onResume: null,
      showTimecardAdd: false,
      showStart: false,
      showPause: false,
      showResume: false,
      canDrag: false,
      timer: buildTimer(null),
      hideActions: false,
      stopAndCreateNewTimeCard: null,
      showVisibleOption: false,
      onToggleVisibility: null,
      isDragging: false,
      connectDragSource: null,
      connectDragPreview: null,
      onCompleteSubtask: null,
      onCollapse: null,
      dragEnable: false,
      isExpanded: false
    }
  }

  _onCompleteSubtask (subtaskIndex, bCompleted) {
    const { onCompleteSubtask } = this.props
    if (onCompleteSubtask) {
      onCompleteSubtask(subtaskIndex, bCompleted)
    }
  }

  render () {
    const {
      task,
      onEdit,
      active,
      showTimecardAdd,
      showStart,
      showPause,
      showResume,
      timer,
      onChangePriority,
      onToggleCompleted,
      onAddTime,
      onStart,
      onPause,
      onResume,
      stopAndCreateNewTimeCard,
      isDragging,
      hideActions,
      showVisibleOption,
      onToggleVisibility,
      dragEnable,
      onCollapse,
      isExpanded
    } = this.props
    const { showExpand } = this.data
    const _class = classnames('ptask-item', {
      showsubtask: isExpanded,
      active,
      isdragging: isDragging
    })

    const connectDragPreview =
      this.props.connectDragPreview || this._defaultDragRender

    const hasSubtasks = task.subtasks && task.subtasks.length > 0

    return connectDragPreview(
      <div className={_class}>
        <div className='taskcontent'>
          <div className='taskinfo taskinfo-selection'>
            {hasSubtasks && (
              <IconButton
                icon={showExpand ? 'arrow-up' : 'arrow-down'}
                iconSize='12'
                className='collapse'
                canHover
                onClick={ev =>
                  onCollapse && onCollapse(!isExpanded, task.id, ev)
                }
              />
            )}
            <div className='taskinfo taskinfo-image'>
              <IconButton
                size='big'
                icon='tasks'
                type='transparent'
                hasBorder
                canHover
              />
            </div>
          </div>

          <div className='task-title'>{task.title}</div>
          <div
            className='task-description'
            dangerouslySetInnerHTML={{ __html: task.description }}
          />
          <div className='task-project-name'>
            {task.project?.title}
          </div>
          <div className='task-client-name'>
            {task.project?.contact?.company}
          </div>
          <div
            className='task-due-date'
          >
            {DateUtil.getDisplayDate(task.dueDate)}
          </div>
          <div className='task-assignee'>
            <div className='data'>
              {task.user ? task.user.displayName : '-'}
            </div>
          </div>
          <div className='task-project-hour'>
            <span className='data'>
              {showPause ? (
                <TimeClock
                  type='task'
                  timer={timer}
                  timeSpent={task.timeSpent}
                  stopAndCreateNewTimeCard={stopAndCreateNewTimeCard}
                />
              ) : (
                Util.convertMinutesToHour(task.timeSpent || 0)
              )}
            </span>
          </div>
          <div className='task-budget-hour'>
            {Util.convertMinutesToHour(task.duration || 0)}
          </div>
          <div className='task-time'>
            {this.props.activityIsActive && (
              <TaskTime
                showTimecardAdd={showTimecardAdd}
                showStart={showStart}
                showPause={showPause}
                showResume={showResume}
                onAddTime={onAddTime}
                onPause={onPause}
                onResume={onResume}
                onStart={onStart}
              />)
            }
          </div>
          <div className='task-priority'>
            <FieldPriority
              active={task.priority}
              size='small'
              showOnlyActive
              onChange={onChangePriority}
            />
          </div>
          <div className='task-status'>
            {!hideActions && (
              <div className='data'>
                <TaskAction taskCompleted={task.completed} onToggleCompleted={onToggleCompleted} onToggleVisibility={onToggleVisibility} onEdit={onEdit} showVisibleOption={showVisibleOption} />
              </div>
            )}
          </div>
        </div>
        <div className='tasksubtasks'>
          {hasSubtasks &&
            task.subtasks.map((subtask, idx) => (
              <TaskSubItem
                key={idx}
                item={subtask}
                dragEnable={dragEnable}
                onCompleteSubtask={this._onCompleteSubtask.bind(this, idx)}
              />
            ))}
        </div>
      </div>
    )
  }

  _onCollapseItem (ev) {
    ev.preventDefault()

    this.data.showExpand = !this.data.showExpand
    this.setState({ dataDate: new Date() })
  }

  _defaultDragRender (node) {
    return node
  }
}

const WithDragSource = dragSource(
  _props => 'all',
  taskItemSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
    dragItem: monitor.getItem()
  })
)(TaskItem)

export { WithDragSource }

export default TaskItem
